class BrandProfilePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'brand_profile.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'brand_profile._m';

    // Access scope - ALL: Can access all brand profiles
    static ACCESS_SCOPE_ALL = 'brand_profile.access.scope.all';

    // Access scope - WORKSPACE: Can access only brand profiles, which owners are in the same workspace
    static ACCESS_SCOPE_WORKSPACE = 'brand_profile.access.scope.workspace';

    // Access scope - OWNER: Can access only owned brand profiles
    static ACCESS_SCOPE_OWNER = 'brand_profile.access.scope.owner';

    // Can access archived brand profiles
    static ACCESS_ARCHIVE = 'brand_profile.access.archive';

    // Can create brand profiles
    static CREATE = 'brand_profile.create';

    // Can create brand profiles with skipped quota check
    static CREATE_FORCED = 'brand_profile.create.force';

    // Update brand profile info
    static UPDATE = 'brand_profile.update';

    // Archive brand profile
    static ARCHIVE = 'brand_profile.archive';

    // Restore archived brand profile
    static RESTORE = 'brand_profile.restore';
}

export default BrandProfilePermission;
